export enum ModuleTestStatus {
  AVAILABLE_FOR_TEST,
  IN_TEST,
  TRIAL_EXPIRED,
  SUBSCRIBED,
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/module-test-status.enum.ts